<section>

    <div class="row mb-3">
        <div class="col-md-6">
            <h4 class="font-weight-bold text-white"><i class="ri-arrow-left-line mr-2 cursor-pointer" (click)="location.back()"></i>{{params}}</h4>
        </div>
        <div class="col-md-6">
            <div class="text-right">
                <button class="btn btn-outline-primary mb-0 text-uppercase" type="button"
                             (click)="location.back()">Cancel</button>
                        <button class="btn btn-primary mb-0 text-uppercase ml-3" (click)="onSubmit(form)" type="button" appPermissionButton accessType="write">Save</button>
            </div>
        </div>
    </div>
    <div class="">
        <div class="">
            
            

            <form #form="ngForm">
                <div class="card">
                    <div class="card-body pt-1">
                        <div class="header">
                            <p>Creds</p>
                        </div>
                        <div class="row">
                            <div class="col-lg-10 col-md-10">
                                <div class="row">
                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <input type="text" appMatInput class="form-control" id="client_id"
                                                name="client_id" [(ngModel)]="lhndDetails.client_id" #client_id="ngModel" required>
                                            <label for="client_id" class="mat-label">Client ID</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <input type="text" appMatInput class="form-control" id="client_secret"
                                                name="client_secret" [(ngModel)]="lhndDetails.client_secret" #client_secret="ngModel" required>
                                            <label for="client_secret" class="mat-label">Client Secret</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <select name="selection_of_secret_id" id="selection_of_secret_id" appMatInput class="custom-select" [(ngModel)]="lhndDetails.selection_of_secret_id" #selection_of_secret_id="ngModel" required>
                                                <option value="client_secret">client_secret</option>
                                                <option value="client_secret_2">client_secret_2</option>
                                            </select>
                                            <!-- <input type="text" appMatInput class="form-control" id="selection_of_secret_id"
                                                name="selection_of_secret_id" [(ngModel)]="lhndDetails.selection_of_secret_id" #selection_of_secret_id="ngModel" required> -->
                                            <label for="selection_of_secret_id" class="mat-label">Selection of Secret ID</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <input type="text" appMatInput class="form-control" id="client_secret_2"
                                                name="client_secret_2" [(ngModel)]="lhndDetails.client_secret_2" #client_secret_2="ngModel" required>
                                            <label for="client_secret_2" class="mat-label">Client Secret 2</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mt-3">
                    <div class="card-body pt-1">
                        <div class="header">
                            <p>Government Based Settings</p>
                        </div>
                        <div class="row">
                            <div class="col-lg-10 col-md-10">
                                <div class="row">
                                    
                                    
                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <select name="government_site" id="government_site" appMatInput class="custom-select" [(ngModel)]="lhndDetails.government_site" #government_site="ngModel" required>
                                                <option value="preprod-api.myinvois.hasil.gov.my">preprod-api.myinvois.hasil.gov.my</option>
                                                <option value="api.myinvois.hasil.gov.my">api.myinvois.hasil.gov.my</option>
                                            </select>
                                            <label for="government_site" class="mat-label">Government Site</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-6 col-md-6">
                                        <div class="form-group">
                                            <select name="current_version" id="current_version" appMatInput class="custom-select" [(ngModel)]="lhndDetails.current_version" #current_version="ngModel" required>
                                                <option value="1.0">1.0</option>
                                                <option value="1.1">1.1</option>
                                            </select>
                                            <label for="current_version" class="mat-label">Current Version</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>